import React from 'react';
import { Alert, Spinner } from 'react-bootstrap';

interface EditableProps {
    handleCancel: () => void;
    handleSave: (x: string) => void;
    isEditing?: boolean;
    isSubmitting?: boolean;
    placeholder?: string;
    readonlyText?: null | string;
    serverError?: null | string | { message: string }[];
    writeableText: string;
}
function Editable({
    handleCancel,
    handleSave,
    isEditing = false,
    isSubmitting = false,
    placeholder = '',
    readonlyText = '',
    serverError = null,
    writeableText,
}: EditableProps) {
    const [newText, setNewText] = React.useState(writeableText);

    function cancel() {
        setNewText(writeableText);
        handleCancel();
    }
    function save(e: React.MouseEvent<HTMLElement>) {
        e.stopPropagation();
        handleSave(newText);
    }

    if (!isEditing) return <span>{newText + readonlyText}</span>;

    return (
        <>
            <div className="d-flex align-items-center">
                <input
                    className="form-control my-3 me-2"
                    maxLength={250}
                    onChange={(e) => setNewText(e.target.value)}
                    placeholder={placeholder}
                    required
                    type="text"
                    value={newText}
                />
                <span className="me-3">.pdf</span>
            </div>
            {serverError && (
                <Alert variant="danger" className="mt-sm-3">
                    {Array.isArray(serverError) ? (
                        <ul className="mb-0">
                            {serverError.map((x) => (
                                <li key={x.message}>{x.message}</li>
                            ))}
                        </ul>
                    ) : (
                        serverError
                    )}
                </Alert>
            )}
            <div className="text-end">
                <button className="btn btn-secondary me-2" type="button" onClick={cancel}>
                    Cancel
                </button>
                <button
                    className="btn btn-primary"
                    type="button"
                    onClick={save}
                    disabled={isSubmitting || newText.trim().length === 0}
                >
                    {isSubmitting && (
                        <Spinner
                            animation="border"
                            variant="light"
                            size="sm"
                            role="status"
                            className="me-1"
                        />
                    )}
                    Save
                </button>
            </div>
        </>
    );
}

export { Editable };
